const { renderReady, render } = require("../../src/utils");

module.exports = class {
    onCreate(input) {
        this.state = {
            placementId: input.placementId,
            module: input.module,
            content: undefined,
            eventFireCount: 0,
        };
    }

    onMount() {
        const { module } = this.state;
        if(module && module.event && module.event.type && module.callback) {
            const { event } = module;
            // Switch case to accomodate new event types (delay for example)
            switch(event.type) {
                case "View": {
                    this.handleViewEvent(event, module.callback);
                    break;
                }
            }
        }
    }

    // Two types of View event: Pixel and Percentage
    handleViewEvent(event, cb) {
        const { visibility } = event;
        if(visibility && visibility.value && visibility.unit) {
            const visibilityValue = ((visibility.unit === 'PIXEL') ? visibility.value : (visibility.value / 100 * window.innerHeight)); 
            this.handleViewWithValue(visibilityValue, cb);
        }
    }
    handleViewWithValue(visibilityValue, cb) {
        if(cb && cb.url && cb.method && cb.body) {
            document.addEventListener('scroll', () => {
                if (this.state.eventFireCount === 0 && window.scrollY >= visibilityValue) {
                    this.state.eventFireCount = 1;
                    fetch(cb.url, {
                        method: 'POST',
                        headers: Object.assign({'Content-Type': 'application/json'}, cb.headers),
                        body: JSON.stringify(cb.body)
                      }).then((response) => {
                          if (response.status && response.status == 200) {  
                            return response.json();
                          }
                      })
                      .then((res) => {
                          if(res && res.modules && res.modules[`PLACEMENT_${this.state.placementId}`]) {
                            this.state.content = res.modules[`PLACEMENT_${this.state.placementId}`];
                          }
                      }).catch((error) => {
                          console.error(error);
                      });
                }
            });
        }
    }
};